import registerModulesWithRouter from 'src/config/AccessControl/registerModulesWithRouter';
import FirmwareModules from 'src/content/management/Firmwares/module';
import FirmwareVariantModules from 'src/content/management/FirmwareVarient/module';
import FirmwareVersionModules from 'src/content/management/FirmwareVersions/module';
import FirmwareLifecycleModules from 'src/content/management/FirmwareLifecycles/module';

const firmwareManagementRoutes = [
  registerModulesWithRouter(FirmwareModules),
  registerModulesWithRouter(FirmwareVariantModules),
  registerModulesWithRouter(FirmwareVersionModules),
  registerModulesWithRouter(FirmwareLifecycleModules)
];

export default firmwareManagementRoutes;
